<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="loading"
      @cancle="cancel"
      @confirm="confirm"
      size="normal"
  >
    <template #header>更换手机</template>
    <template #content>
      <el-form
          :model="form"
          label-width="120px"
          ref="form"
          label-position="top"
      >
        <el-form-item
            :class="{'login-phoneNumber':isMain}"
            prop="phone"
            :label="isMain ? '验证新手机' : '手机号码'"
            style="margin-bottom: 5px"
            :rules="[
              {required: true, message: '请输入手机号码', trigger: ['blur', 'change']},
              $gjReRule(phoneReg, '请输入正确的手机号码')
            ]"
        >
          <gj-input placeholder="请输入手机号码" v-model="form.phone" width="245px">
            <template slot="prefix" v-if="isMain">
              <gj-select
                  :clearable="false"
                  :filterable="false"
                  :options="codeOptions"
                  v-model="form.telephoneCode"
                  width="90px"
              ></gj-select>
            </template>
          </gj-input>
        </el-form-item>
        <template v-if="isMain">
          <el-form-item
              prop="code"
              label="验证码"
              :rules="[
              {required: true, message: '请输入验证码', trigger: ['blur', 'change']},
            ]"
              style="margin-bottom: 6px"
          >
            <gj-input placeholder="请输入验证码" style="margin-right: 10px" width="144px" v-model="form.code"></gj-input>
            <gj-button
                plain
                type="ghost"
                size="mini"
                class="v-code"
                :disabled="registerCaptchaDisabled"
                @click="registerCaptcha()">
              <template v-if="registerCaptchaDisabled">
                {{registerCaptchaTime}}s后重发
              </template>
              <template v-else>
                获取验证码
              </template>
            </gj-button>
          </el-form-item>
        </template>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, modalMixIn} from "../../../../minxins";
  import {editPhone, updateNewPhoneCaptcha} from "../../../../api/personal-center";
  import {isMeaningless} from "../../../../utils/common";
  import { tcAuthCode } from "@/utils/common";
  export default {
    name: "edit-phone",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      isMain: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loading: false,
        form: {
          phone: null,
          code: null,
          telephoneCode: '86',
        },
        codeOptions: [
          {id: '86', text: '+86(CN)'},
          {id: '1', text: '+1 (US)'},
        ],
        regs: {
          // '86': /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
          '86': /^(\d{10}|\d{11})$/,
          '1': /^(\d{10}|\d{11})$/
        },
        registerCaptchaDisabled: false,
        registerCaptchaTime: null,
      }
    },
    computed: {
      phoneReg() {
        return this.regs[this.form.telephoneCode]
      }
    },
    methods: {
      registerCaptcha() {
        this.$refs.form.validateField('phone', err => {
          if (err) { // 手机号码校验不通过
            return;
          }
          // 腾讯图形验证码
          tcAuthCode(this.form.phone).then(resolve => {
            updateNewPhoneCaptcha({mobile: this.form.phone, code:resolve}, this.form.telephoneCode).then(res => {
              this.registerCaptchaDisabled = true;
              this.registerCaptchaTime = 120;
              const intervalHandle = setInterval(() => {
                if (this.registerCaptchaTime > 0) {
                  this.registerCaptchaTime--;
                } else {
                  this.registerCaptchaDisabled = false;
                  clearInterval(intervalHandle);
                }
              }, 1000);
            })
          }).catch(error => {
            // 未验证
          });
        })

      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          editPhone(this.form.phone, isMeaningless(this.form.code) ? '' : this.form.code, this.isMain ? this.form.telephoneCode : '')
            .then((res) => {
              if (res.code === 0) {
                this.$gjMessage.success(res.msg);
              }
              if (res.code !== 0) {
                this.$gjMessage.error(res.msg);
              } else {
                this.$emit('after');
              }
            }).complete(() => this.loading = false)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .gj-modal--normal .el-dialog {
    width: 420px;
  }
  /deep/ .el-form--label-top .el-form-item__label {
    float: none;
    display: initial;
    text-align: left;
    padding: 0 0 10px 0;
  }
  .login-phoneNumber{
    &/deep/.el-input__inner{
      padding-left: 100px;
    }
    &/deep/.el-input__prefix{
      height: 30px;
      // margin-top: 1px;
    }
    &/deep/.el-select__caret{
      color: #333333;
      font-weight: bold;
    }

    &/deep/.gj-select{
      height: 30px;
      .el-input{
        height: 30px;
      }
      .el-input__inner{
        padding: 0 0 0 10px;
        border: none;
        height: 30px;
        line-height: 30px;
      }
      .el-input__suffix{
        top: 2px;
      }
    }
  }
</style>
